import { Routes, RouterModule } from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';

// export function loadChildren(path) { return System.import(path); };

// GUARD PARA LOGIN
import { AuthGuard } from 'app/services/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: 'app/pages/login/login.module#LoginModule',
  },
  {
    path: 'modulos',
    component: Pages,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: './dashboard/dashboard.module#DashboardModule',
      },
      {
        path: 'shoppings',
        canActivate: [AuthGuard],
        loadChildren: './shoppings/shoppings.module#ShoppingsModule',
      },
      {
        path: 'promocoes',
        canActivate: [AuthGuard],
        loadChildren: './promocoes/promocoes.module#PromocoesModule',
      },
      {
        path: 'pessoas',
        canActivate: [AuthGuard],
        loadChildren: './pessoas/pessoasRouter.module#PessoasRouterModule',
      },
      {
        path: 'beneficios', children: [
          {
            path: '',
            redirectTo: 'beneficios',
            pathMatch: 'full',
          },
          {
            path: 'beneficios',
            canActivate: [AuthGuard],
            loadChildren: './beneficios/beneficios/beneficios.module#BeneficiosModule',
          },
          {
            path: 'controle',
            canActivate: [AuthGuard],
            loadChildren: './beneficios/controle/controle.module#ControleModule',
          },
          {
            path: 'controlecafes',
            canActivate: [AuthGuard],
            loadChildren: './beneficios/controlecafes/controlecafes.module#ControlecafesModule',
          },
        ],
      },
      {
        path: 'brindes', children: [
          { path: '', redirectTo: 'produtos', pathMatch: 'full' },
          {
            path: 'produtos',
            canActivate: [AuthGuard],
            loadChildren: './brindes/produtos/produtos.module#ProdutosModule',
          },
          {
            path: 'estoque',
            canActivate: [AuthGuard],
            loadChildren: './brindes/estoque/estoque.module#EstoqueModule',
          },
        ],
      },
      {
        path: 'terminais',
        canActivate: [AuthGuard],
        loadChildren: './terminais/terminais.module#TerminaisModule',
      },
      {
        path: 'rotinas',
        loadChildren: './rotinas/rotinas.module#RotinasModule',
      },
      {
        path: 'configuracoes',
        canActivate: [AuthGuard],
        loadChildren: './configuracoes/configuracoes.module#ConfiguracoesModule',
      },
      {
        path: 'relatorios',
        loadChildren: './relatorios/relatorios.module#RelatoriosModule',
      },
      {
        path: 'extras', children: [
          {
            path: 'roletapremiada',
            canActivate: [AuthGuard],
            loadChildren: './extras/roletapremiada/roletapremiada.module#RoletaPremiadaModule',
          },
        ],
      },
    ],
  },
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/pages.routing.ts